import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimoniosSection() {
  const testimonials = [{
    quote: 'Me dio recursos listos y me ordenó el año completo de Geografía. Lo recomiendo a todos mis colegas.',
    name: 'María Fernanda López',
    role: 'Docente de Geografía',
    city: 'Buenos Aires'
  }, {
    quote: 'Arranqué marzo con todo armado. Los cuadernillos cubren todos los ejes que necesito.',
    name: 'Carlos Andrés Ruiz',
    role: 'Profesor de Geografía',
    city: 'Córdoba'
  }, {
    quote: 'Muy completo y adaptable a mi planificación provincial. Mis alumnos entienden mucho mejor con este material.',
    name: 'Luciana Gómez',
    role: 'Docente de secundaria',
    city: 'Rosario'
  }, {
    quote: 'Como directora, lo compré para todo el departamento de Ciencias Sociales. Nos ahorró meses de planificación.',
    name: 'Paula Martínez',
    role: 'Directora de escuela',
    city: 'Mendoza'
  }, {
    quote: 'Siendo estudiante de profesorado, este kit me adelantó años de experiencia práctica en Geografía.',
    name: 'Valentina Sánchez',
    role: 'Estudiante de profesorado',
    city: 'La Plata'
  }];
  return <section id="testimonios" className="py-8 sm:py-14 bg-white" data-id="element-260">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-261">
        <div className="text-center mb-6 sm:mb-10" data-id="element-262">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-2 sm:mb-3" data-id="element-263">
            Testimonios de docentes
          </h2>
          <p className="text-gray-500 text-xs sm:text-base" data-id="element-264">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4" data-id="element-265">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-50 p-4 sm:p-6 rounded-xl border border-gray-200 relative" data-id="element-266">
              <Quote className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-300 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-267" />

              <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-268">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-269" />)}
              </div>

              <p className="text-gray-700 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-270">
                "{t.quote}"
              </p>

              <div className="mt-auto" data-id="element-271">
                <p className="text-gray-900 font-bold text-xs sm:text-sm" data-id="element-272">
                  {t.name}
                </p>
                <p className="text-gray-500 text-[10px] sm:text-xs" data-id="element-273">{t.role}</p>
                <p className="text-gray-400 text-[9px] sm:text-[10px] mt-0.5" data-id="element-274">
                  {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}